import { render, staticRenderFns } from "./DetailRowEdit.vue?vue&type=template&id=72098e05"
import script from "./DetailRowEdit.vue?vue&type=script&lang=js"
export * from "./DetailRowEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports